import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

// Components
import { FullHeightWrapperComponent } from './full-height-wrapper/full-height-wrapper.component';
import { LoaderComponent } from './loader/loader.component';
import { NotAvailableOfflineComponent } from './not-available-offline/not-available-offline.component';
import { PwaNotAvailableComponent } from './pwa-not-available/pwa-not-available.component';
import { WebserviceErrorComponent } from './webservice-error/webservice-error.component';
import { ListElementComponent } from './list-element/list-element.component';
import { HeaderComponent } from './header/header.component';

const COMPONENTS = [
  FullHeightWrapperComponent,
  ListElementComponent,
  LoaderComponent,
  NotAvailableOfflineComponent,
  PwaNotAvailableComponent,
  WebserviceErrorComponent,
  HeaderComponent,
];

@NgModule({
  imports: [CommonModule, IonicModule, RouterModule, FormsModule, TranslateModule.forChild()],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class ComponentsModule {}
